<template>
    <div>
        <slot name="button" :show-modal="showModal"></slot>
        <transition name="modal">
            <div v-if="shown" class="modal-mask" @click="onBackdropClick">
                <div class="modal-wrapper">
                    <div class="modal-container" :class="size === 'xlarge' ? 'modal-xl' : (size === 'large' ? 'modal-lg' : '')" @click.stop>

                        <div v-if="hasSlot('header')" class="modal-header">
                            <slot name="header" :close-modal="closeModal"></slot>
                        </div>

                        <div v-if="hasSlot('body')" class="modal-body">
                            <slot name="body" :close-modal="closeModal"></slot>
                        </div>

                        <div v-if="hasSlot('footer')" class="modal-footer">
                            <slot name="footer" :close-modal="closeModal"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                shown: false,
            };
        },

        props: {
            size: {
                type: String,
                required: false,
            },

            closeOnBackdropClick: {
                type: Boolean,
                required: false,
                default: true,
            },
        },

        methods: {
            showModal() {
                this.shown = true;

                document.body.style.overflow = 'hidden';

                this.$emit('opened');
            },

            onBackdropClick() {
                this.$emit('backdrop-clicked');

                if (this.closeOnBackdropClick) {
                    this.closeModal();
                }
            },

            closeModal() {
                this.shown = false;

                document.body.style.overflow = null;

                this.$emit('closed');
            },

            hasSlot(name = 'default') {
                return !!this.$slots[name] || !!this.$scopedSlots[name];
            },
        },
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        height: 100%;
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        display: flex;
        flex-direction: column;
        height: auto;
        max-width: 500px;
        max-height: 90vh;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-container.modal-lg {
        max-width: 800px;
    }

    .modal-container.modal-xl {
        max-width: 1600px;
    }

    .modal-header {
        padding: 0.5rem;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        overflow: auto;
        max-height: 80vh;
        margin: 10px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
